/* @flow */
import getGooglePlayLink from 'utils/getGooglePlayLink';
import Image from 'components/Image.jsx';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import React from 'react';
import UserAgent from 'lib/UserAgent';
import cx from 'classnames';

import './styles/AppDownloadImageLinks.scss';

class AppDownloadImageLinks extends React.Component {
  static propTypes = {
    align: React.PropTypes.oneOf(['left', 'center']),
    showText: React.PropTypes.bool,
  };

  static contextTypes = {
    provided: React.PropTypes.object,
  };

  static defaultProps = {
    align: 'center',
  };

  renderLinks() {
    const iosDownloadLink = (
      <Link
        href={LinkConstants.APP_STORE}
        target="_blank"
        className="AppDownloadImageLinks-item"
        eventElementName="AppDownloadImageLinks-item">
        <Image
          src={require('assets/images/app-stores/app-store.svg')}
          alt="Download on the App Store"
          className="AppDownloadImageLinks-item-img"
        />
      </Link>
    );

    // TODO(turadg) make this (or something like it) always available at the root app context
    const provided = this.context.provided || {};
    const authToken = provided.cookies ? (provided.cookies['auth_token'] || null) : undefined;

    const androidDownloadLink = (
      <Link
        href={getGooglePlayLink(authToken)}
        target="_blank"
        className="AppDownloadImageLinks-item"
        eventElementName="AppDownloadImageLinks-item">
        <Image
          src={require('assets/images/app-stores/google-play.svg')}
          alt="Get it on Google Play"
          className="AppDownloadImageLinks-item-img"
        />
      </Link>
    );

    const userAgent = new UserAgent(provided.userAgentStr || window.navigator.userAgent);

    if (userAgent.ios()) {
      return iosDownloadLink;
    }
    if (userAgent.android()) {
      return androidDownloadLink;
    }
    return (
      <div className="AppDownloadImageLinks-links">
        {iosDownloadLink}
        {androidDownloadLink}
      </div>
    );
  }

  render() {
    return (
      <div
        className={cx('AppDownloadImageLinks', {
          'AppDownloadImageLinks--left': this.props.align === 'left',
        }, this.props.className)}
        size="small">
        {this.props.showText &&
          <h3 className="AppDownloadImageLinks-title">Download the app</h3>
        }
        {this.renderLinks()}
      </div>
    );
  }
}

export default AppDownloadImageLinks;



// WEBPACK FOOTER //
// ./src/components/AppDownloadImageLinks.jsx